<template>
  <div class="pondSettingEdit" style="width:97.8%;border:1px solid #e0e0e0;margin-left:14px;">
    <div class="titleForm-container">{{edit?"编辑塘口":"查看塘口"}}</div>
    <div :class="{'content-form-container':true,'readonly':edit===false}">
      <div class="main-container-form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
          <el-form-item label="所在基地" prop="fishBaseId">
            <el-select v-model="ruleForm.fishBaseId" placeholder="请选择所在基地" style="width:100%;">
              <el-option v-for="(item,index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="塘口编号" prop="pondNumber">
            <el-input v-model="ruleForm.pondNumber" placeholder="请输入塘口编号" type="text" :maxlength="num" size="medium" style="width:100%;" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-row :gutter="5">
            <el-form-item label="主养品种" required>
              <el-col :span="12">
                <el-form-item prop="fishCategoryId">
                  <el-select v-model="fishCategoryList" placeholder="请选择鱼分类名称" size="medium" style="width:100%;" @change="changeFishGetCategory">
                    <el-option v-for="item in fishGetCategory" :key="item.key" :label="item.value" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="fishCategoryList">
                <el-form-item prop="fishId">
                  <el-select v-model="ruleForm.fishName" @change="getFishName" placeholder="请选择鱼种类型" size="medium" style="width:100%;">
                    <el-option v-for="item in fishGetCategoryName" :key="item.key" :label="item.value" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row :gutter="5">
            <el-form-item label="养殖类型" required>
              <el-col :span="12">
                <el-form-item prop="cultivationTypeId">
                  <el-select v-model="ruleForm.cultivationTypeId" placeholder="请选择养殖类型" size="medium" style="width:100%;">
                    <el-option v-for="item in cultureTypeList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="fishTypeId">
                  <el-select v-model="ruleForm.fishTypeId" placeholder="请选择渔种类型" size="medium" style="width:100%;">
                    <el-option v-for="item in fishTypeList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="养殖模式" prop="modeId">
            <el-select v-model="ruleForm.modeId" placeholder="请选择养殖模式" size="medium" style="width:100%;">
              <el-option v-for="item in cultureModeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="塘口面积" prop="pondArea">
            <el-input v-model="ruleForm.pondArea" type="text" :maxlength="num1" size="medium" placeholder="请输入面积" style="width:100%;" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
              <i slot="suffix" style="font-style:normal">亩</i>
            </el-input>
          </el-form-item>
          <el-form-item label="平均水深" prop="avgDeep">
            <el-input v-model="ruleForm.avgDeep" type="text" :maxlength="num1" size="medium" placeholder="请输入水深" style="width:100%;" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
              <i slot="suffix" style="font-style:normal">米</i>
            </el-input>
          </el-form-item>
          <el-form-item label="塘口负责人" prop="leaderId">
            <el-select v-model="ruleForm.leaderId" placeholder="请选择负责人" style="width:100%;">
              <el-option v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-col :span="8">
              <el-button class="edit-save-btn" type="primary" @click="editSubmitForm('ruleForm')"> 保存</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
export default {
  name: "pondSettingEdit",
  data() {
    return {
      edit: false,
      id: this.$route.query.id,
      num: 20,
      num1: 7,
      fishCategoryList: "", // 鱼分类选择监听列表
      fishNameList: "", // 鱼分类下名称监听列表
      ruleForm: {
        fishBaseId: "", //所在基地
        pondNumber: "", //塘口编号
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "", // 鱼分类名称
        cultivationTypeId: "", // 养殖类型
        fishTypeId: "", // 渔种类型
        modeId: "", // 养殖模式
        pondArea: "", //塘口面积
        avgDeep: "", //平均水深
        leaderId: "" // 塘口负责人
      },
      cultureTypeList: [], //养殖类型
      fishTypeList: [], //渔种类型
      cultureModeList: [], //养殖模式
      companyUser: [], //负责人
      baseList: [], //基地
      rules: {
        fishBaseId: [
          { required: true, message: "请输入所在基地", trigger: "change" }
        ],
        pondNumber: [
          { required: true, message: "请输入塘口编号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "塘口编号格式不对,请重新输入"
          }
        ],
        fishCategoryId: [
          { required: true, message: "请选择鱼分类名称", trigger: "change" }
        ],
        fishId: [
          { required: true, message: "请选择鱼种名称", trigger: "change" }
        ],
        cultivationTypeId: [
          { required: true, message: "请选择养殖类型", trigger: "change" }
        ],
        fishTypeId: [
          { required: true, message: "请选择渔种类型", trigger: "change" }
        ],
        modeId: [
          { required: true, message: "请选择养殖模式", trigger: "change" }
        ],
        pondArea: [
          { required: true, message: "请输入塘口面积", trigger: "blur" },
          {
            pattern: /^[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "塘口面积格式不对,请重新输入"
          }
        ],
        avgDeep: [
          { required: true, message: "请输入平均水深", trigger: "blur" },
          {
            pattern: /^[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "平均水深格式不对,请重新输入"
          }
        ],
        leaderId: [
          { required: true, message: "请选择塘口负责人", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    ...mapActions(modules.pond, [
      "getEditPondData", //获取塘口单行数据
      "editPondSettingList" //编辑-保存数据
    ]),
    ...mapActions(modules.dataDict, [
      "getCultureType", //养殖类型
      "getFishType", //渔种类型
      "getCultureMode" //养殖模式
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory", // 获取渔种信息
      "getFishGetCategoryName" // 获取分类渔种名称
    ]),
    ...mapActions(modules.base, ["getBaseList"]), //基地
    ...mapActions(modules.user, ["getCompanyUser"]),
    //分类渔种---
    changeFishGetCategory(val) {
      this.ruleForm.fishCategoryName = val.value;
      this.ruleForm.fishCategoryId = val.key;
      this.getFishGetCategoryName(this.ruleForm.fishCategoryId)
        .then(rsp => {
          if (rsp.status === 200) {
            this.fishNameList = "";
            this.ruleForm.fishName = "";
            this.ruleForm.fishId = "";
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    getFishName(val) {
      this.ruleForm.fishName = val.value;
      this.ruleForm.fishId = val.key;
    },
    //获取鱼分类下得鱼种
    getFishNameData() {
      this.getFishGetCategory()
        .then(rsp => {
          console.log(rsp);
          // this.getFishGetCategoryName(this.ruleForm.fishCategoryId);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //编辑--获取当前行数据
    getCurrPondData() {
      this.getEditPondData(this.id)
        .then(rsp => {
          console.log(33, rsp);
          if (rsp.status === 200) {
            this.getFishGetCategoryName(rsp.data.fishCategoryId);
            this.ruleForm = rsp.data || [];
            this.fishCategoryList = rsp.data.fishCategoryName;
            this.fishNameList = rsp.data.fishName;
          }
          console.dir(rsp);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //编辑---保存
    editSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.id, //行id
            fishBaseId: this.ruleForm.fishBaseId,
            no: this.ruleForm.pondNumber,
            area: this.ruleForm.pondArea,
            fishCategoryId: this.ruleForm.fishCategoryId,
            fishId: this.ruleForm.fishId,
            fishCategoryName: this.ruleForm.fishCategoryName,
            fishName: this.ruleForm.fishName,
            cultivationTypeId: this.ruleForm.cultivationTypeId,
            fishTypeId: this.ruleForm.fishTypeId,
            modeId: this.ruleForm.modeId,
            avgDeep: this.ruleForm.avgDeep,
            leaderId: this.ruleForm.leaderId
          };
          this.editPondSettingList(obj)
            .then(rsp => {
              console.dir(rsp);
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                history.go(-1);
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
              // console.dir(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    }
  },
  async mounted() {
    this.edit = await checkPermission.initPagePermission(this.$route, { permissionId: 501 });
    document.title = this.edit ? "编辑塘口设置" : "查看塘口设置";
    let baseList = await this.getBaseList(); //基地信息
    this.baseList = baseList;
    let result = await this.getCompanyUser(1); //获取负责人
    this.companyUser = result;
    let cultureTypeList = await this.getCultureType(); //养殖类型
    this.cultureTypeList = cultureTypeList;
    let fishTypeList = await this.getFishType(); //渔种类型
    this.fishTypeList = fishTypeList;
    let cultureModeList = await this.getCultureMode(); //养殖模式
    this.cultureModeList = cultureModeList;
    this.getFishNameData();
    this.getCurrPondData();
    // this.changeFishGetCategory();
  },
  computed: {
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"])
  }
};
</script>

<style >
</style>
